import type { MapViewModule } from "../../../@types/mapviewxs";
import type { State } from "../types";

export const initialState: Partial<State> = {
  isPreviewCardEnabled: false,
  prevSelectedItems: [],
  selectedItems: [],
  highlightedItem: null,
  prevHighlightedItem: null,
  clusterPointsOfInterest: [],
  isLoadMoreVisible: false,
  showErrorMessage: false,
  isLeftRailItemHover: false,
  isLoadingMoreItems: false,
  isEmptyMapTrackerVisible: false,
};

export function stateFromModel(model?: MapViewModule): Partial<State> {
  return {
    isLoading: !model?.pointsOfInterest, // When points of interest are not provided, the loading state is set to true until listings are fetched
    help: model?.help,
    survey: model?.survey,
    surveyButton: model?.surveyButton,
    pointsOfInterest: model?.pointsOfInterest || [],
    leftRailItems: model?.pointsOfInterest || [],
    resetMapviewButton: model?.resetMapviewButton,
    mapMessage: model?.mapMessage,
    mapAccessibilityTexts: model?.mapAccessibilityTexts,
    itemCardControls: {
      itemCardNavigationAction: model?.itemCardNavigationAction || {},
      sellerListingCountLabel: model?.sellerListingCountLabel || {},
      itemCardCloseAction: model?.itemCardCloseAction || {},
    },
  };
}
